var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"footer__link",on:{"click":_vm.openHistoryModal}},[_vm._v("Nuestra historia")])
}
var staticRenderFns = []

export { render, staticRenderFns }